import React from "react"
import { Route, Routes } from "react-router-dom"
import { Flex, SkipLink, Text, Modal } from "@capioweb/ui-components/src"
import { PageAndBlockResolver } from "./pages"
import { Header, Footer, AlertBanner } from "./components"
import { UIContext, LocalesContext } from "./context"
import { Z_INDEX } from "./constants"

export const AppShell: React.FC = (props) => {
	const { pageAlerts } = React.useContext(UIContext)
	const { translate, translationKeys } = React.useContext(LocalesContext)

	const hasPageAlerts =
		pageAlerts?.common?.length > 0 || pageAlerts?.local?.length > 0

	return (
		<>
			<Modal zIndex={Z_INDEX.Modal} />
			<Flex display="block" as="nav">
				<SkipLink>
					<Text mb={0}>{translate(translationKeys.skipLinkLabel)}</Text>
				</SkipLink>
			</Flex>
			{hasPageAlerts && <AlertBanner pageAlerts={pageAlerts} />}
			<Header />
			<Routes>
				<Route path="*" element={<PageAndBlockResolver />} />
			</Routes>
			<Footer />
			<div id="legitscript">
				<a
					href="https://legitscript.com/websites/?checker_keywords=capio.se"
					target="_blank"
					title="Verify LegitScript Approval"
				>
					<img
						src="https://static.legitscript.com/seals/17519443.png"
						alt="LegitScript approved"
						width="140"
						height="100"
					/>
				</a>
			</div>
		</>
	)
}
